import React, { Fragment, useContext, useState } from "react";
import * as styles from "./magazine.module.css";
import { StatusType } from "../../services/firebase/auth-context/reducer";
import AuthContext from "../../services/firebase/auth-context/provider";
import Login from "../login/login";
import { toEuroString } from "../../util/format/euro";
import MagazineBuyForm from "../forms/magazines/form";
import LoadingSpinner from "../common/loading-spinner";
import MakroAlert, { MakroAlertType } from "../common/alert";
import { buyMagazine } from "../../services/monsum/magazines/buy";
export let MagazineBuyState = /*#__PURE__*/ function (MagazineBuyState) {
    MagazineBuyState[MagazineBuyState["INACTIVE"] = 0] = "INACTIVE";
    MagazineBuyState[MagazineBuyState["BUY"] = 1] = "BUY";
    MagazineBuyState[MagazineBuyState["BUY_AGAIN"] = 2] = "BUY_AGAIN";
    return MagazineBuyState;
}({});
const MagazineBuy = _ref => {
    let { number, price, soldOut, onlyDigital, setBuyState } = _ref;
    const { authenticated, userData } = useContext(AuthContext)[0];
    const { 0: resultState, 1: setResultState } = useState("none");
    const { 0: buyRequestIsSubmitting, 1: setBuyRequestIsSubmitting } = useState(false);
    const onSuccess = () => {
        setResultState("success");
        setTimeout(() => {
            setBuyState(MagazineBuyState.INACTIVE);
            window.location.reload();
        }, 5000);
    };
    const buyRequest = data => {
        setBuyRequestIsSubmitting(true);
        buyMagazine({
            number: number,
            customer: null,
            payment: null,
            legal: null
        }).then(res => {
            res ? onSuccess() : setResultState("failure");
            setBuyRequestIsSubmitting(false);
        }).catch(() => {
            setResultState("failure");
            setBuyRequestIsSubmitting(false);
        });
    };
    const onSubmit = (values, _ref2) => {
        let { setSubmitting } = _ref2;
        setSubmitting(true);
        buyMagazine(mapRequestData(number, values)).then(res => {
            setSubmitting(false);
            if (res) {
                onSuccess();
            }
            else {
                setResultState("failure");
            }
        }).catch(() => {
            setSubmitting(false);
            setResultState("failure");
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.buyBox
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mb-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ React.createElement("strong", null, "Erwerben Sie dieses Themenheft"), /*#__PURE__*/ React.createElement("br", null), renderProductDescription(price, soldOut, onlyDigital)), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col justify-center"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: () => setBuyState(MagazineBuyState.INACTIVE),
        className: "text-sm italic"
    }, "Abbrechen"))), resultState === "success" ? renderAlertSuccess(soldOut, onlyDigital) : resultState === "failure" ? renderAlertFailure() : !authenticated ? /*#__PURE__*/ React.createElement(Login, null) : isLoading(userData) ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : isCustomer(userData) ? renderBuy(price, soldOut, onlyDigital, buyRequest, buyRequestIsSubmitting) : /*#__PURE__*/ React.createElement(MagazineBuyForm, {
        onSubmit: onSubmit,
        submitButtonText: buyButtonText(price, soldOut, onlyDigital)
    }));
};
const isLoading = userData => userData && userData.status === StatusType.LOADING;
const isCustomer = userData => userData && userData.status === StatusType.SUCCESS && userData.data.customerId;
const renderProductDescription = (price, soldOut, onlyDigital) => /*#__PURE__*/ React.createElement("small", null, "(", soldOut || onlyDigital ? "Digital" : "Print & Digital", "-Version f\xFCr ", toEuroString(price), ")");
const buyButtonText = (price, soldOut, onlyDigital) => /*#__PURE__*/ React.createElement("strong", null, soldOut || onlyDigital ? "Digital" : "Print & Digital", "-Version f\xFCr ", toEuroString(price), " kaufen");
const renderBuy = (price, soldOut, onlyDigital, buyFunction, isSubmitting) => /*#__PURE__*/ React.createElement("div", {
    className: "text-center py-2"
}, /*#__PURE__*/ React.createElement("div", {
    className: "text-center mx-auto mb-3",
    style: {
        maxWidth: "390px"
    }
}, "Mit Klick auf den nachfolgenden Button best\xE4tigen Sie, dass Sie die ", /*#__PURE__*/ React.createElement("a", {
    href: "/agb",
    target: "_blank",
    className: "text-makroOrange underline hover:no-underline"
}, "AGB"), " zur Kenntnis genommen haben."), !isSubmitting ? /*#__PURE__*/ React.createElement("button", {
    onClick: () => buyFunction(),
    className: "btn-makroPurple"
}, buyButtonText(price, soldOut, onlyDigital)) : /*#__PURE__*/ React.createElement(LoadingSpinner, null));
const renderAlertSuccess = (soldOut, onlyDigital) => /*#__PURE__*/ React.createElement(MakroAlert, {
    type: MakroAlertType.SUCCESS,
    title: "Vielen Dank!",
    text: `Sie haben das Themenheft erfolgreich erworben. Sie werden in wenigen Sekunden weitergeleitet und können das Themenheft herunterladen.` + (soldOut || onlyDigital ? "" : " Zudem erhalten Sie die Print-Version in den nächsten Tagen per Post.")
});
const renderAlertFailure = () => /*#__PURE__*/ React.createElement(MakroAlert, {
    type: MakroAlertType.DANGER,
    title: "Das hat leider nicht geklappt",
    text: /*#__PURE__*/ React.createElement(Fragment, null, "Es ist ein Fehler aufgetreten. Wir helfen Ihnen gerne weiter: ", /*#__PURE__*/ React.createElement("a", {
        href: "mailto:technik@makroskop.eu",
        className: "underline"
    }, "technik@makroskop.eu"), ".")
});
const mapRequestData = (magazineNumber, values) => {
    return {
        number: magazineNumber,
        customer: {
            salutation: values.customer.salutation,
            firstName: values.customer.firstName,
            lastName: values.customer.lastName,
            email: values.customer.email,
            street: values.customer.street,
            zipcode: values.customer.postalCode,
            city: values.customer.city,
            country: values.customer.country
        },
        payment: {
            method: values.payment_method.method,
            bankAccountOwner: values.payment_method.account_owner,
            bankName: values.payment_method.bank,
            bankBIC: values.payment_method.bic,
            bankIBAN: values.payment_method.iban,
            paymentToken: values.payment_method.stripe_token
        },
        legal: {
            agb: values.legal.agb,
            privacy: values.legal.privacy
        }
    };
};
export default MagazineBuy;
